"use client";
import React from "react";
import { FaTimes, FaEnvelope } from "react-icons/fa";
import styles from "./ContactModal.module.css";

/**
 * Props
 * ───────────────────────────────────────────────────────────
 * open   – boolean  → whether the modal is shown
 * onClose – () => void  → callback to close the modal
 */
export default function ContactModal({ open, onClose }) {
  if (!open) return null;           // Don’t render if not open

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Close Button */}
        <button className={styles.closeBtn} onClick={onClose}>
          <FaTimes />
        </button>

        {/* Heading */}
        <div className={styles.heading}>
          <FaEnvelope className={styles.headingIcon} />
          <h3>Contact Me</h3>
        </div>

        {/* Google Form (INLINE IFRAME) */}
        <iframe
          title="Contact-Me Google Form"
          src="https://forms.gle/MQs2NWeDFsxNKaEQ6?embedded=true"
          width="100%"
          height="600"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          loading="lazy"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}
